module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('ibox', [_c('template', {
    slot: "title"
  }, [_vm._v("通知テンプレート一覧")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "forum-title"
  }, [_c('h3', [_vm._v("自動配信メール")])]), _vm._v(" "), _vm._l((_vm.mails), function(notice) {
    return [_c('div', {
      staticClass: "forum-item active"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "forum-icon"
    }, [_c('i', {
      staticClass: "fa fa fa-star"
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "forum-item-title",
      attrs: {
        "to": '/notice/edit/' + notice.alias
      }
    }, [_vm._v(_vm._s(notice.name))]), _vm._v(" "), _c('div', {
      staticClass: "forum-sub-title",
      domProps: {
        "innerHTML": _vm._s(notice.note)
      }
    }), _vm._v(" "), _c('br')], 1)])])]
  })], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9d63906"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/notice/List.vue
// module id = 492
// module chunks = 1